import React from "react";
import PropTypes from "prop-types";
import css from "./css/LandingPage.scss";
import {getWord} from "utils/tenant";
import StyledButton from "common/StyledButton";
import Icon from "SF/MaterialIcon";
import StudentSurveyList from "./StudentSurveyList";

function LandingPage({createSurvey, duplicateTemplate, displayToast, editSurvey, tenantDateFormat, viewQuestionBank}) {
    const studentSurveys = getWord('studentSurveys', false);
    const studentSurvey = getWord('studentSurvey', false);

    return (
        <div className={css['container']}>
            <h1 className={css['header']}>{studentSurveys}</h1>
            <hr aria-hidden />
            <div className={css['student-surveys-help-text']}>
                Add a {studentSurvey} to collect information about students. To see all available questions and add new
                ones, use the Manage Question Bank button. To Edit, Pause, or Duplicate an existing {studentSurvey},
                use the Actions column in the table. {studentSurveys} in Draft state are hidden from all non-Tenant
                Admin roles and are fully editable. Students can only view questions on Open {studentSurveys}. For more
                information on the statuses, refer to the Starfish Help Center.
            </div>
            <div className={css['navigation-buttons']}>
                <StyledButton className={css['new-survey-button']} onClick={createSurvey}>
                    <>
                        <Icon icon="add" aria-hidden={true} />
                        Add {getWord('studentSurvey', false)}
                    </>
                </StyledButton>
                <StyledButton inverted onClick={viewQuestionBank}>
                    Manage Question Bank
                </StyledButton>
            </div>
            <div className={css['survey-list']}>
                <StudentSurveyList duplicateTemplate={duplicateTemplate} editSurvey={editSurvey} tenantDateFormat={tenantDateFormat} displayToast={displayToast} />
            </div>
        </div>
    )
}

LandingPage.propTypes = {
    createSurvey: PropTypes.func.isRequired,
    duplicateTemplate: PropTypes.func.isRequired,
    displayToast: PropTypes.func.isRequired,
    editSurvey: PropTypes.func.isRequired,
    tenantDateFormat: PropTypes.string.isRequired,
    viewQuestionBank: PropTypes.func.isRequired
};

export default LandingPage;
